// activity-specific leisure map points + neutral AI wording in leisure mode
export const I18N_POI = {
 "en": {
  "poi_jetty": "⚓ Dock / Jetty",
  "poi_slip": "🛶 Entry/Exit (Slip)",
  "poi_harbor": "⛵ Harbor / Marina",
  "poi_shallow": "🪨 Shoal / Sandbank",
  "poi_buoy": "🟠 Buoy / Anchorage",
  "poi_weir": "🚧 Weir / Portage",
  "poi_bathing": "🏊 Swimming Area",
  "poi_fuel": "⛽ Gas Station / Supply",
  "poi_signpost": "🪧 Signpost / Junction",
  "poi_wc": "🚻 Restroom",
  "poi_trailhead": "🚩 Trailhead / Start",
  "poi_lift": "🚡 Lift / Cable Car",
  "poi_avalanche": "❄️ Avalanche Danger",
  "poi_charge": "🔌 Charging Station",
  "poi_repair": "🔧 Workshop / Pump",
  "poi_pass": "🏔️ Pass / Summit",
  "poi_fishspot": "🎣 Fishing Spot",
  "poi_catch": "🐟 Catch",
  "poi_nofish": "⛔ Protected Area / No Fishing",
  "poi_stand": "🪜 High Seat / Blind",
  "poi_trail": "🐾 Game Trail",
  "poi_feed": "🌾 Bait Site / Feeding Station",
  "poi_stable": "🐴 Stable / Farm",
  "poi_gate": "🚪 Gate / Passage",
  "poi_berry": "🫐 Berries",
  "poi_herb": "🌿 Herbs",
  "poi_stage": "📍 Stage / Waypoint",
  "poi_final": "🏁 Final",
  "aiAssist": "AI Assistant",
  "fsPlanAi": "Plan Route (AI)",
  "trkNone": "This sector has no recording activities. For tours switch to the Leisure or All sector."
 },
 "it": {
  "poi_jetty": "⚓ Pontile / Molo",
  "poi_slip": "🛶 Entrata/Uscita (Scivolo)",
  "poi_harbor": "⛵ Porto / Marina",
  "poi_shallow": "🪨 Secca / Banco di sabbia",
  "poi_buoy": "🟠 Boa / Punto d'ancoraggio",
  "poi_weir": "🚧 Sbarramento / Portage",
  "poi_bathing": "🏊 Area balneare",
  "poi_fuel": "⛽ Stazione servizio / Rifornimento",
  "poi_signpost": "🪧 Segnaletica / Bivio",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Partenza / Inizio",
  "poi_lift": "🚡 Impianto / Funivia",
  "poi_avalanche": "❄️ Pericolo valanghe",
  "poi_charge": "🔌 Stazione di ricarica",
  "poi_repair": "🔧 Officina / Pompa",
  "poi_pass": "🏔️ Passo / Vetta salita",
  "poi_fishspot": "🎣 Posto di pesca",
  "poi_catch": "🐟 Cattura",
  "poi_nofish": "⛔ Area protetta / Divieto",
  "poi_stand": "🪜 Postazione / Capanno",
  "poi_trail": "🐾 Passaggio fauna",
  "poi_feed": "🌾 Pasturazione / Mangiatoia",
  "poi_stable": "🐴 Stalla / Maso",
  "poi_gate": "🚪 Cancello / Passaggio",
  "poi_berry": "🫐 Bacche",
  "poi_herb": "🌿 Erbe",
  "poi_stage": "📍 Tappa / Stazione intermedia",
  "poi_final": "🏁 Finale",
  "aiAssist": "Assistente IA",
  "fsPlanAi": "Pianifica percorso (IA)",
  "trkNone": "In questo settore non ci sono attività da registrare. Per i percorsi passa al settore Tempo libero o Tutti."
 },
 "es": {
  "poi_jetty": "⚓ Embarcadero / Muelle",
  "poi_slip": "🛶 Acceso/Salida (Rampa)",
  "poi_harbor": "⛵ Puerto / Marina",
  "poi_shallow": "🪨 Bajo / Banco de arena",
  "poi_buoy": "🟠 Boya / Fondeadero",
  "poi_weir": "🚧 Presa / Porteo",
  "poi_bathing": "🏊 Zona de baño",
  "poi_fuel": "⛽ Gasolinera / Suministro",
  "poi_signpost": "🪧 Indicador / Bifurcación",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Inicio / Salida",
  "poi_lift": "🚡 Teleférico / Telesilla",
  "poi_avalanche": "❄️ Peligro de aludes",
  "poi_charge": "🔌 Estación de carga",
  "poi_repair": "🔧 Taller / Bomba",
  "poi_pass": "🏔️ Puerto / Cima",
  "poi_fishspot": "🎣 Zona de pesca",
  "poi_catch": "🐟 Captura",
  "poi_nofish": "⛔ Zona protegida / Prohibido",
  "poi_stand": "🪜 Puesto elevado / Torre",
  "poi_trail": "🐾 Paso de fauna",
  "poi_feed": "🌾 Cebadero / Comedero",
  "poi_stable": "🐴 Establo / Granja",
  "poi_gate": "🚪 Puerta / Paso",
  "poi_berry": "🫐 Bayas",
  "poi_herb": "🌿 Hierbas",
  "poi_stage": "📍 Etapa / Parada intermedia",
  "poi_final": "🏁 Final",
  "aiAssist": "Asistente IA",
  "fsPlanAi": "Planificar ruta (IA)",
  "trkNone": "Este sector no tiene actividades de grabación. Para rutas cambie al sector Ocio o Todos."
 },
 "pt": {
  "poi_jetty": "⚓ Cais / Pontão",
  "poi_slip": "🛶 Entrada/Saída (Rampa)",
  "poi_harbor": "⛵ Porto / Marina",
  "poi_shallow": "🪨 Baixio / Banco de areia",
  "poi_buoy": "🟠 Boia / Ancoradouro",
  "poi_weir": "🚧 Açude / Portagem",
  "poi_bathing": "🏊 Local de banho",
  "poi_fuel": "⛽ Posto / Abastecimento",
  "poi_signpost": "🪧 Placa / Bifurcação",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Entrada / Partida",
  "poi_lift": "🚡 Teleférico / Elevador",
  "poi_avalanche": "❄️ Perigo de avalanche",
  "poi_charge": "🔌 Estação de carregamento",
  "poi_repair": "🔧 Oficina / Bomba",
  "poi_pass": "🏔️ Passo / Topo da subida",
  "poi_fishspot": "🎣 Local de pesca",
  "poi_catch": "🐟 Captura",
  "poi_nofish": "⛔ Zona protegida / Proibição",
  "poi_stand": "🪜 Torre de caça / Miradouro",
  "poi_trail": "🐾 Passagem de animais",
  "poi_feed": "🌾 Comedouro / Local de alimentação",
  "poi_stable": "🐴 Estábulo / Quinta",
  "poi_gate": "🚪 Portão / Passagem",
  "poi_berry": "🫐 Bagas",
  "poi_herb": "🌿 Ervas",
  "poi_stage": "📍 Etapa / Paragem intermédia",
  "poi_final": "🏁 Final",
  "aiAssist": "Assistente IA",
  "fsPlanAi": "Planear rota (IA)",
  "trkNone": "Este setor não tem atividades de gravação. Para percursos mude para o setor Lazer ou Todos."
 },
 "fr": {
  "poi_jetty": "⚓ Débarcadère / Ponton",
  "poi_slip": "🛶 Mise à l'eau (Slip)",
  "poi_harbor": "⛵ Port / Marina",
  "poi_shallow": "🪨 Haut-fond / Banc de sable",
  "poi_buoy": "🟠 Bouée / Mouillage",
  "poi_weir": "🚧 Barrage / Portage",
  "poi_bathing": "🏊 Zone de baignade",
  "poi_fuel": "⛽ Station-service / Ravitaillement",
  "poi_signpost": "🪧 Panneau / Bifurcation",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Départ / Début",
  "poi_lift": "🚡 Remontée / Téléphérique",
  "poi_avalanche": "❄️ Danger d'avalanche",
  "poi_charge": "🔌 Borne de recharge",
  "poi_repair": "🔧 Atelier / Pompe",
  "poi_pass": "🏔️ Col / Sommet de montée",
  "poi_fishspot": "🎣 Lieu de pêche",
  "poi_catch": "🐟 Prise",
  "poi_nofish": "⛔ Zone protégée / Interdit",
  "poi_stand": "🪜 Mirador / Affût",
  "poi_trail": "🐾 Passage du gibier",
  "poi_feed": "🌾 Agrainage / Mangeoire",
  "poi_stable": "🐴 Écurie / Ferme",
  "poi_gate": "🚪 Portail / Passage",
  "poi_berry": "🫐 Baies",
  "poi_herb": "🌿 Herbes",
  "poi_stage": "📍 Étape / Station intermédiaire",
  "poi_final": "🏁 Final",
  "aiAssist": "Assistant IA",
  "fsPlanAi": "Planifier itinéraire (IA)",
  "trkNone": "Ce secteur n’a pas d’activités d’enregistrement. Pour les parcours, passez au secteur Loisirs ou Tous."
 },
 "sq": {
  "poi_jetty": "⚓ Vend ankorimi / Pontun",
  "poi_slip": "🛶 Hyrje/Dalje (Slip)",
  "poi_harbor": "⛵ Port / Marina",
  "poi_shallow": "🪨 Cekëtinë / Bankë rëre",
  "poi_buoy": "🟠 Bojë / Vend ankorimi",
  "poi_weir": "🚧 Digë / Vend bartjeje",
  "poi_bathing": "🏊 Vend larjeje",
  "poi_fuel": "⛽ Pikë karburanti / Furnizim",
  "poi_signpost": "🪧 Tabelë / Udhëkryq",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Hyrje / Fillim",
  "poi_lift": "🚡 Teleferik / Funikulari",
  "poi_avalanche": "❄️ Rrezik lavine",
  "poi_charge": "🔌 Stacion karikimi",
  "poi_repair": "🔧 Punëtori / Pompë",
  "poi_pass": "🏔️ Qafë / Maja ngjitje",
  "poi_fishspot": "🎣 Vend peshkimi",
  "poi_catch": "🐟 Gjah",
  "poi_nofish": "⛔ Zonë e mbrojtur / Ndalim",
  "poi_stand": "🪜 Stand gjuetie / Kështjellë",
  "poi_trail": "🐾 Kalim kafshësh",
  "poi_feed": "🌾 Vend ushqimi",
  "poi_stable": "🐴 Stallë / Fermë",
  "poi_gate": "🚪 Portë / Kalim",
  "poi_berry": "🫐 Mana",
  "poi_herb": "🌿 Barna",
  "poi_stage": "📍 Etapë / Stacion ndërmjetës",
  "poi_final": "🏁 Përfundim",
  "aiAssist": "Asistent AI",
  "fsPlanAi": "Planifiko rrugën (AI)",
  "trkNone": "Ky sektor nuk ka aktivitete regjistrimi. Për ture kaloni te sektori Kohë e lirë ose Të gjitha."
 },
 "de": {
  "poi_jetty": "⚓ Anlegestelle / Steg",
  "poi_slip": "🛶 Ein-/Ausstieg (Slip)",
  "poi_harbor": "⛵ Hafen / Marina",
  "poi_shallow": "🪨 Untiefe / Sandbank",
  "poi_buoy": "🟠 Boje / Ankerplatz",
  "poi_weir": "🚧 Wehr / Umtragestelle",
  "poi_bathing": "🏊 Badestelle",
  "poi_fuel": "⛽ Tankstelle / Versorgung",
  "poi_signpost": "🪧 Wegweiser / Abzweig",
  "poi_wc": "🚻 WC",
  "poi_trailhead": "🚩 Einstieg / Start",
  "poi_lift": "🚡 Lift / Bergbahn",
  "poi_avalanche": "❄️ Lawinengefahr",
  "poi_charge": "🔌 Ladestation",
  "poi_repair": "🔧 Werkstatt / Pumpe",
  "poi_pass": "🏔️ Pass / Anstieg-Top",
  "poi_fishspot": "🎣 Angelplatz",
  "poi_catch": "🐟 Fang",
  "poi_nofish": "⛔ Schonbereich / Verbot",
  "poi_stand": "🪜 Hochsitz / Kanzel",
  "poi_trail": "🐾 Wildwechsel",
  "poi_feed": "🌾 Kirrung / Futterstelle",
  "poi_stable": "🐴 Stall / Hof",
  "poi_gate": "🚪 Tor / Durchlass",
  "poi_berry": "🫐 Beeren",
  "poi_herb": "🌿 Kräuter",
  "poi_stage": "📍 Stage / Zwischenstation",
  "poi_final": "🏁 Final",
  "aiAssist": "KI-Assistent",
  "fsPlanAi": "Route planen (KI)",
  "trkNone": "In dieser Branche gibt es keine Aufzeichnungs-Tätigkeiten. Wechseln Sie für Touren in die Branche Freizeit oder Alle."
 }
};
